import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { Coupon } from 'commons/models/coupon';
import { AppContext, EMPTY_OBJECT, getClonedData } from 'commons-ui';

import useService from '../../utils/useService';
import { FORM_FIELD_KEYS } from '../../utils/formConfig';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateCoupon } = useService();

	const formDefaults = {
		validFrom: new Date().getTime(),
		validTill: new Date().getTime(),
		maxConversionPerRedemption: EMPTY_OBJECT
	};

	const cloneCoupon = (clonedData: Coupon) => {
		setShowLoader(true);
		requestCreateCoupon(app.appName, { ...clonedData, isDisabled: true }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the partner coupon'}`, { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Record created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (data: any) => {
		cloneCoupon(dehydrateFormData(data));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(getClonedData(_get(location, ['state', 'rowData']), FORM_FIELD_KEYS, formDefaults)),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
